module.exports = __webpack_public_path__ + "img/card-bg2-2.6b4266cb.png";